import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { notifications } from '@mantine/notifications'
import { useUsuarioDetalhe, useUsuarioUpdate } from '../../hooks/useUsuarios'
import styles from '../_shared/CrudPage.module.css'
import formStyles from '../_shared/CrudForm.module.css'

const PERFIS = [
  { value: 'rt_mecanico', label: 'RT Mecânico' },
  { value: 'rt_qai', label: 'RT QAI' },
  { value: 'executora', label: 'Técnico / Executora' },
  { value: 'admin_tenant', label: 'Administrador' },
  { value: 'cliente', label: 'Cliente' },
]

function extractError(err: unknown): string {
  const e = err as { response?: { data?: Record<string, unknown> } }
  const data = e?.response?.data ?? {}
  for (const k of ['detail', 'perfil', 'ativo', 'registro_profissional']) {
    const v = data[k]
    if (Array.isArray(v) && v.length) return `${k}: ${v[0]}`
    if (typeof v === 'string') return `${k}: ${v}`
  }
  return 'Erro ao salvar.'
}

export default function UsuarioDetalhePage() {
  const { id = '' } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const detalhe = useUsuarioDetalhe(id)
  const update = useUsuarioUpdate(id)

  const [perfil, setPerfil] = useState('')
  const [registro, setRegistro] = useState('')
  const [ativo, setAtivo] = useState(true)

  useEffect(() => {
    if (detalhe.data) {
      setPerfil(detalhe.data.perfil)
      setRegistro(detalhe.data.registro_profissional ?? '')
      setAtivo(detalhe.data.ativo ?? true)
    }
  }, [detalhe.data])

  if (detalhe.isLoading) return <div className={styles.loading}>Carregando...</div>
  if (detalhe.error || !detalhe.data) {
    return <div className={styles.empty}>Usuário não encontrado.</div>
  }
  const u = detalhe.data

  async function handleSalvar(e: React.FormEvent) {
    e.preventDefault()
    try {
      await update.mutateAsync({
        perfil,
        registro_profissional: registro,
        ativo,
      })
      notifications.show({ color: 'green', message: 'Usuário atualizado.' })
    } catch (err) {
      notifications.show({
        color: 'red',
        title: 'Falha',
        message: extractError(err),
      })
    }
  }

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <button
            className={styles.backBtn}
            type="button"
            onClick={() => navigate('/usuarios')}
          >
            ← Voltar
          </button>
          <h1 className={styles.title}>{u.nome_completo}</h1>
          <p style={{ margin: '0.25rem 0', color: '#666' }}>{u.email}</p>
        </div>
      </header>

      <form onSubmit={handleSalvar} className={formStyles.form}>
        <section className={formStyles.section}>
          <h2 className={formStyles.sectionTitle}>Permissões</h2>
          <div className={formStyles.grid2}>
            <div className={formStyles.field}>
              <label htmlFor="perfil">Perfil</label>
              <select
                id="perfil"
                data-testid="usuario-edit-perfil"
                value={perfil}
                onChange={(e) => setPerfil(e.target.value)}
              >
                {PERFIS.map((p) => (
                  <option key={p.value} value={p.value}>
                    {p.label}
                  </option>
                ))}
              </select>
            </div>

            <div className={formStyles.field}>
              <label htmlFor="reg">Registro profissional</label>
              <input
                id="reg"
                data-testid="usuario-edit-registro"
                value={registro}
                onChange={(e) => setRegistro(e.target.value)}
                placeholder="ex.: CREA-SP 5061701055"
              />
            </div>

            <div className={formStyles.field}>
              <label style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                <input
                  type="checkbox"
                  data-testid="usuario-edit-ativo"
                  checked={ativo}
                  onChange={(e) => setAtivo(e.target.checked)}
                />
                Conta ativa
              </label>
              <small style={{ color: '#666' }}>
                Desmarcar bloqueia login e remove o usuário das listagens.
              </small>
            </div>
          </div>
        </section>

        <div className={formStyles.actions}>
          <button
            type="submit"
            className={formStyles.btnPrimary}
            disabled={update.isPending}
            data-testid="usuario-edit-submit"
          >
            {update.isPending ? 'Salvando...' : 'Salvar alterações'}
          </button>
        </div>
      </form>
    </div>
  )
}
